/**
 * Flag du tableau de bord admin (SAAS-1219).
 *
 * @remarks
 * La page est câblée, mais reste cachée tant qu'elle n'a pas été validée sur
 * des données réelles. Dans un fichier à part, et non dans le manifest, pour
 * que `AdminNavView` lise le flag sans embarquer le manifest.
 */
export const ADMIN_DASHBOARD_FEATURE_FLAG = 'admin-dashboard';
